import { useNavigate } from 'react-router-dom';

import CircularCheck from '../../assets/circular-check.png';
import Styles from './Success.module.css';

const Success = () => {
  const navigate = useNavigate();

  return (
    <div className={Styles.pageContainer}>
      <img src={CircularCheck} alt={'Circular check'} />
      <h1>Success!</h1>
      <h2>Your purchase has been proccessed successfully</h2>
      <h3>You'll receive an email with your membership codes shortly.</h3>
      <button onClick={() => navigate('/flashcards')}>Back to Dashboard</button>
    </div>
  );
};

export default Success;
